import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { useThemeContext } from '../lib/theme-context';
import { MfaChallengeGate } from './MfaChallengeGate';

interface ProtectedRouteProps {
  readonly children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const { isThemeLoaded } = useThemeContext();

  // Still resolving auth session from persisted storage
  if (loading) return null;

  // Auth resolved: no user → redirect to login immediately
  if (!user) return <Navigate to="/login" replace />;

  // User authenticated: wait for theme before rendering children
  if (!isThemeLoaded) return null;

  // Authenticated but the second factor may still be owed. Password sign-in
  // yields a valid aal1 session even when a factor is enrolled, and the API
  // rejects aal1 for superadmins who have one — so prompt before rendering.
  return <MfaChallengeGate>{children}</MfaChallengeGate>;
}
